<template>
  <sme-card v-if="visible" :title="$t('modulrSortCodeBanner.title')" class="modulr-sort-code-banner">
    <p class="mb-0">{{ $t('modulrSortCodeBanner.body') }}</p>
    <template #footer>
      <b-button variant="outline-primary" class="modulr-sort-code-banner__dismiss" @click="dismiss">
        {{ $t('modulrSortCodeBanner.dismiss') }}
      </b-button>
    </template>
  </sme-card>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import SmeCard from '@/components/atoms/SmeCard.vue';
import useModulrSortCode from '@/composables/useModulrSortCode';
import State from '@/state/State';

// Bump the prefix to show the banner again after a new message. That needs a deploy.
const DISMISS_KEY_PREFIX = 'modulr_sortcode_banner_v1';

// The repo runs @vue/vue2-jest 27, which does not compile <script setup>, so the bindings
// never reach the render function under test. Keep the Options API setup() form.
export default {
  name: 'ModulrSortCodeBanner',
  components: { SmeCard },
  setup() {
    // The company property decides the audience, so no operator sets a flag per company.
    // The copy names both sort codes, so the component needs no value from the company.
    const { isOnNewModulrSortCode } = useModulrSortCode();

    // Company scoped, so a dismiss for one company does not hide the banner for another
    // company in the same browser.
    const dismissKey = `${DISMISS_KEY_PREFIX}_${State.state.company?.company_id}`;

    // Assume dismissed until onMounted reads localStorage, to avoid a flash of the banner.
    const dismissed = ref(true);
    const visible = computed(() => isOnNewModulrSortCode.value && !dismissed.value);

    onMounted(() => {
      try {
        dismissed.value = window.localStorage.getItem(dismissKey) === '1';
      } catch {
        // Safari private mode throws on localStorage. Show the banner.
        dismissed.value = false;
      }
    });

    const dismiss = () => {
      dismissed.value = true;

      try {
        window.localStorage.setItem(dismissKey, '1');
      } catch {
        // The banner returns on the next page load. That is better than a broken button.
      }
    };

    return { dismiss, visible };
  },
};
</script>
